import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8eeabca8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "parameters-edit-form" }
const _hoisted_2 = { class: "parameters-edit-form_controls" }
const _hoisted_3 = { class: "parameters-edit-form_create-template" }
const _hoisted_4 = { class: "parameters-edit-form_create-template_buttons" }

import { computed, PropType, ref } from "vue";
import { ParametersTemplateModel, TaskParameterModel, TaskParameterTypeEnum } from "@/components";
import { TaskParametersTable, TaskParametersInput } from "../components";
import {
  TirPmPopover,
  PopoverPositionEnum,
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmInput,
} from "tir-components";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'parameters-edit-form',
  props: {
  /**Тип настройки */
  type: { type: Number as PropType<TaskParameterTypeEnum> },
  /**Список шаблонов */
  templates: { type: Array as PropType<ParametersTemplateModel[]> },
  /**Редактируемые параметры */
  editParameters: { type: Array as PropType<TaskParameterModel[]> },
  /**Заблокировано создание шаблона */
  createTemplateDisabled: { type: Boolean },
  /**Заголовок параметра */
  title: { type: String, default: "" },
  /**Имя области */
  namespaceName: { type: String },
},
  emits: ["upsert", "clearUnused", "createTemplate", "selectTemplate"],
  setup(__props, { emit }) {

const props = __props;


/**События */


/**Объект для демонстрации добавления тега */
const upsertParameter = ref(new TaskParameterModel());
/**Имя нового шаблона */
const templateName = ref("");
/**Компонент поповер */
const $settingsPopover = ref<InstanceType<typeof TirPmPopover>>();

/**Блокировка кнопки очистки, если все параметры используются */
const isClearUnusedDisabled = computed(() => props.editParameters.every((p) => p.InUse));

/**Добавление параметра */
const onUpsertParameter = (parameter: TaskParameterModel) => {
  emit("upsert", new TaskParameterModel(parameter));
  upsertParameter.value = new TaskParameterModel({ Color: upsertParameter.value.Color });
};
/**Очистка не используемых параметров */
const clearUnusedParameters = () => {
  emit("clearUnused");
};
/**Создать шаблон */
const createTemplate = () => {
  emit(
    "createTemplate",
    new ParametersTemplateModel({
      Name: templateName.value,
      Data: JSON.stringify(props.editParameters),
      Type: props.type,
    }),
  );
  closePopover();
};
/**Закрыть поповер */
const closePopover = () => {
  setTimeout(() => $settingsPopover.value?.close?.());
};
/**Выбор шаблона */
const selectTemplate = (template: ParametersTemplateModel) => {
  emit("selectTemplate", template.ParsedData);
  upsertParameter.value = new TaskParameterModel({ Color: upsertParameter.value.Color });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TaskParametersInput), {
      upsertParameter: upsertParameter.value,
      "onUpdate:upsertParameter": _cache[0] || (_cache[0] = ($event: any) => ((upsertParameter).value = $event)),
      "hide-templates": "",
      type: __props.type,
      templates: __props.templates,
      ignoreParameters: __props.editParameters,
      title: __props.title,
      onUpsert: onUpsertParameter,
      onSelectTemplate: selectTemplate
    }, null, 8, ["upsertParameter", "type", "templates", "ignoreParameters", "title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(TirPmPopover), {
        "disable-content-blur": "",
        "is-no-teleport": "",
        width: "22rem",
        ref_key: "$settingsPopover",
        ref: $settingsPopover,
        position: _unref(PopoverPositionEnum).Bottom,
        "is-disabled": __props.createTemplateDisabled
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TirPmButton), {
            variant: _unref(TirPmButtonVariantEnum).SecondaryState,
            size: _unref(TirPmButtonSizeEnum).Small
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Сохранить как шаблон ")
            ]),
            _: 1
          }, 8, ["variant", "size"])
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(TirPmInput), {
              modelValue: templateName.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((templateName).value = $event)),
              isWithHint: false,
              label: "Название шаблона",
              placeholder: "Шаблон",
              ref: "$nameInput"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(TirPmButton), {
                variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                size: _unref(TirPmButtonSizeEnum).Small,
                "is-disabled": !templateName.value,
                onClick: createTemplate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Сохранить ")
                ]),
                _: 1
              }, 8, ["variant", "size", "is-disabled"]),
              _createVNode(_unref(TirPmButton), {
                variant: _unref(TirPmButtonVariantEnum).LinkState,
                size: _unref(TirPmButtonSizeEnum).Small,
                onClick: closePopover
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Отмена ")
                ]),
                _: 1
              }, 8, ["variant", "size"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["position", "is-disabled"]),
      _createVNode(_unref(TirPmButton), {
        variant: _unref(TirPmButtonVariantEnum).LinkState,
        size: _unref(TirPmButtonSizeEnum).Small,
        "is-disabled": isClearUnusedDisabled.value,
        onClick: clearUnusedParameters
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Очистить все ")
        ]),
        _: 1
      }, 8, ["variant", "size", "is-disabled"])
    ]),
    _createVNode(_unref(TaskParametersTable), {
      title: __props.title,
      parameters: __props.editParameters,
      type: __props.type,
      namespaceName: __props.namespaceName
    }, null, 8, ["title", "parameters", "type", "namespaceName"])
  ]))
}
}

})